'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _TobaccoSectors = require('./TobaccoSectors.css');

var _TobaccoSectors2 = _interopRequireDefault(_TobaccoSectors);

var _ = require('..');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TobaccoSectors = (_dec = (0, _reactCssModules2.default)(_TobaccoSectors2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TobaccoSectors, _Component);

  function TobaccoSectors(props) {
    (0, _classCallCheck3.default)(this, TobaccoSectors);
    return (0, _possibleConstructorReturn3.default)(this, (TobaccoSectors.__proto__ || (0, _getPrototypeOf2.default)(TobaccoSectors)).call(this, props));
  }

  (0, _createClass3.default)(TobaccoSectors, [{
    key: 'render',
    value: function render() {
      var toIcon = require('../../../static/images/icon-cigarette.svg');
      var tmIcon = require('../../../static/images/icon-cinema.svg');

      return _react2.default.createElement(
        'div',
        { styleName: 'sectors-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'sectors' },
          _react2.default.createElement(
            'div',
            { styleName: 'sectors-inner' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6, styleName: 'detail-tobacco-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-to' },
                  _react2.default.createElement('img', { styleName: 'detail-icon', src: toIcon, alt: 'Multi-national tobacco companies' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-title' },
                    'Multi-national tobacco companies'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    'Tobacco is the #1 cause of preventable death in the U.S. and ',
                    _react2.default.createElement(
                      'strong',
                      null,
                      _react2.default.createElement(
                        'em',
                        null,
                        'one billion lives'
                      )
                    ),
                    ' are at stake worldwide. Around the world, 180 countries have ratified the ',
                    _react2.default.createElement(
                      _.Link,
                      { to: _config2.default.links.who, xstrong: true, title: 'World Health Organization Framework Convention on Tobacco Control' },
                      'World Health Organization Framework Convention on Tobacco Control.'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, sm: 6, styleName: 'detail-movies-wrapper' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'detail-tm' },
                  _react2.default.createElement('img', { styleName: 'detail-icon', src: tmIcon, alt: 'Tobacco-promoting entertainment companies' }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-title' },
                    'Tobacco-promoting entertainment companies'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'detail-stat' },
                    _react2.default.createElement(
                      _.Link,
                      { to: _config2.default.links.nytarticle, xstrong: true, title: 'New York Times: Why Smoking in Films Harms Children' },
                      'Making kid-rated movies smokefree'
                    ),
                    ' would prevent one million tobacco deaths in this generation of U.S. kids. Hollywood studios and their parent companies are well aware of the public health risk, but continue to expose millions of kids to tobacco.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'sectors-didyouknow' },
              _react2.default.createElement(
                'div',
                { styleName: 'stat' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'stat-label' },
                  'Did you know '
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'stat-count-wrapper' },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'stat-count' },
                    _react2.default.createElement('i', { styleName: 'fa-question' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'sectors-didyouknow-info' },
                'Around the world, 180 countries have committed to combat tobacco addiction, disability and early death \u2014 and ',
                _react2.default.createElement(
                  _.Link,
                  { to: _config2.default.links.whoPdf, xstrong: true, title: 'WHO: Guidelines for implementation of Article 13 of the WHO Framework Convention on Tobacco Control (PDF)' },
                  'end tobacco promotion through the entertainment media.'
                ),
                ' ',
                _react2.default.createElement(
                  _.Link,
                  { to: _config2.default.links.reader, strong: true, title: 'Download Acrobat Reader to view this PDF' },
                  _react2.default.createElement('i', { className: 'fa fa-file-pdf-o' }),
                  _react2.default.createElement(
                    _.SrOnly,
                    null,
                    'Download Acrobat Reader to view this PDF'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TobaccoSectors;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = TobaccoSectors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TobaccoSectors/TobaccoSectors.js
// module id = 1283
// module chunks = 0